/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface ProgramTypeName
 */
export interface ProgramTypeNameOptional {
  /**
   *
   * @type {string}
   * @memberof ProgramTypeName
   */
  programName?: string;
}

export interface ProgramTypeName extends ProgramTypeNameOptional {
  /**
   *
   * @type {string}
   * @memberof ProgramTypeName
   */
  programName?: string;
}

export interface ProgramTypeNameTrackedI {
  /**
   *
   * @type {string}
   * @memberof ProgramTypeName
   */
  programName?: string;
  programNameIsSet: boolean;
}

transformDatesMap.set("ProgramTypeName", function (model: ProgramTypeName) {});

export type ProgramTypeNameMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  programName: PropertyMeta<MetaTypeBase<string>>;
}>;

export var ProgramTypeNameMeta: ProgramTypeNameMetaI =
  {} as ProgramTypeNameMetaI;
ProgramTypeNameMeta = typeMeta("ProgramTypeName", {
  programName: propertyMeta(
    "programName",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = ProgramTypeNameMeta;

registerMeta(() => {});

export class ProgramTypeNameTracked implements ProgramTypeNameTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  programName__I?: string = undefined;
  programNameIsSet: boolean = false;
  set programName(v: undefined | string) {
    if (v !== undefined) {
      this.programName__I = v;
      this.programNameIsSet = true;
    } else {
      this.programName__I = v || undefined;
      this.programNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get programName() {
    return this.programName__I;
  }
  constructor(config?: ProgramTypeNameOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: ProgramTypeNameOptional,
    options?: AssignOptions,
  ): ProgramTypeNameTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.programName &&
      this.programNameApplyFilter(optionsRequired.filter)
    ) {
      this.programName = config.programName;
      if (optionsRequired.unassign) this.programNameIsSet = false;
      else this.programNameIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): ProgramTypeNameTrackedI {
    const cloned = {} as ProgramTypeNameTrackedI;
    if (
      this.programNameIsSetDeep() &&
      this.programNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.programNameIsSet = true;
      cloned.programName = this.programName;
    } else {
      //cloned.programNameIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): ProgramTypeNameTrackedI {
    if (!this.programNameApplyFilter(filter)) this.programNameIsSet = false;

    return this;
  }
  programNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ProgramTypeNameMeta.programName,
      ProgramTypeNameMeta,
      this.programName,
      this,
    );
  }
  programNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.programNameIsSet && this.programNameApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.programNameIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
